import { TextField, type TextFieldProps } from "@/shared/ui/core";

export type NumberFieldProps = TextFieldProps;

/**
 * Un número que se teclea: existencias, puntos, orden, gramos.
 *
 * ── Por qué NO es `type="number"` ────────────────────────────────────
 * En un `<input type="number">` la rueda del ratón cambia el valor
 * mientras se hace scroll por encima. Sobre "Existencias" eso es
 * inventario inventado, y sobre "VP" son puntos de compensación que
 * nadie escribió. Además, `type="number"` deja el campo en blanco
 * cuando alguien escribe algo que no entiende, así que el error se
 * pierde en vez de poder explicarse.
 *
 * `inputMode="numeric"` da lo único que hacía falta de verdad: el
 * teclado numérico del móvil. El valor sigue siendo TEXTO, y quien
 * decide si es un número es el esquema del formulario, que puede
 * decirlo con palabras.
 *
 * Candidato a `shared/ui/fields/` — no sabe nada de productos.
 */
export function NumberField({ inputMode = "numeric", ...rest }: NumberFieldProps) {
  return <TextField inputMode={inputMode} autoComplete="off" {...rest} />;
}
